// 法语
const fr = {
  common: {
    notSupport: 'Votre navigateur ne prend pas en charge le mode plein écran',
    loadFail: 'Échec du chargement du thème',
    noPermission:
      "Désolé, vous n'avez pas la permission d'accéder à cette page",
    backHome: "Retour à la page d'accueil",
    noExit: "La page à laquelle vous essayez d'accéder n'existe pas",
    serverError: 'Désolé, le serveur a rencontré une erreur',
    slide: 'Faites glisser vers la droite',
    veryHigh: 'Très élevé',
    high: 'Élevé',
    target: 'Cible',
    urgentLow: 'Très bas',
    agpNoData:
      'Le rapport AGP nécessite au moins 5 jours de données pour être généré',
    noDataStr: 'Aucune donnée',
    setting: 'Paramètres',
    personInfo: 'Informations de base',
    updatePwd: 'Changer de mot de passe',
    upHead: 'Télécharger des photos',
    inRange: 'Dans la plage',
    normal: 'Normal',
    low: 'Faible',
    previous: 'Précédent',
    next: 'Suivant',
    search: 'Rechercher',
    reset: 'Réinitialiser',
    cancel: 'Annuler',
    ok: 'Ok',
    confirm: 'Confirmer',
    save: 'Enregistrer',
    submit: 'Soumettre',
    successful: 'Réussi',
    pleaseEnter: 'Veuillez entrer',
    pleaseSelect: 'Veuillez sélectionner',
    success: 'Succès',
    confirmLogout: 'Êtes-vous sûr de vouloir vous déconnecter?',
    updateSuccessed: 'Mise à jour réussie',
    warning: 'Avertissement',
    date: 'Date',
    start: 'Début',
    end: 'Fin',
    sevenDays: '7 jours',
    fourteenDays: '14 jours',
    thirtyDays: '30 jours',
    signOut: 'Déconnexion',
    personalInformation: 'Informations personnelles',
    email: 'E-mail',
    name: 'Nom',
    mobile: 'Mobile',
    dateOfBirth: 'Date de naissance',
    gender: 'Genre',
    diabeteType: 'Type de diabète',
    dateOfDignose: 'Année du diagnostic',
    remarks: 'Remarques',
    optionMale: 'Homme',
    optionFemale: 'Femme',
    optionUnknow: 'Préfère ne pas indiquer',
    noDiabetes: 'Pas de diabète',
    diabeteTypeI: 'Type I',
    diabeteTypeII: 'Type II',
    diabeteSpecial: 'Spécial',
    diabeteGestational: 'Diabète gestationnel',
    diabeteOthers: 'Autres',
    ruleMsgEmail: 'Veuillez saisir votre e-mail',
    ruleMsgName: 'Veuillez saisir votre nom',
    ruleMsgMobile: 'Veuillez saisir votre numéro de mobile',
    ruleMsgBirthday: 'Veuillez sélectionner votre date de naissance',
    ruleMsgSex: 'Veuillez sélectionner votre genre',
    ruleMsgDiabeteType: 'Veuillez sélectionner le type de diabète',
    ruleMsgDateOfDignose: "Veuillez sélectionner l'année du diagnostic",
    ruleMsgRemarks: 'Veuillez entrer une remarque',
    ruleMsgCorrectMobile: 'Veuillez entrer le numéro de mobile correct',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    ruleMsgOldPassword: "Veuillez entrer l'ancien mot de passe",
    ruleMsgNewPassword: 'Veuillez entrer le nouveau mot de passe',
    ruleMsgConfirmPassword: 'Veuillez confirmer le mot de passe',
    passwordInconsistent: 'Les deux mots de passe sont incohérents',
    passwordModifySuccessed:
      'Votre mot de passe a été réinitialisé, veuillez vous reconnecter !',
    monday: 'Lun',
    tuesday: 'Mar',
    wednesday: 'Mer',
    thursday: 'Jeu',
    friday: 'Ven',
    saturday: 'Sam',
    sunday: 'Dim',
    sn: 'SN',
    startDate: 'Date de début',
    days: 'jours',
    pdfDate: 'Objectif',
    close: 'fermer',
    inputTip: 'Veuillez entrer des mots-clés pour rechercher',
    polarization: "Appareil en cours d'initialisation",
    hour: 'h',
    minutes: 'min',
    seconds: 's',
    reportDownLoadTip: "Votre rapport n'a pas été généré depuis 5 jours.",
    age: 'âge',
    goal: 'Objectif',
    expired: 'Capteur expiré',
    lastTime: 'Dernière heure de mise à jour',
    timeZone: 'Fuseau horaire'
  },
  route: {
    login: 'Connexion',
    forget: 'Mot de passe oublié',
    home: 'Accueil',
    glucoseReport: 'Rapport de glycémie',
    sessionReport: 'Rapport de session',
    eventList: 'Liste des événements',
    followerList: 'Liste des abonnés',
    followerListQ: "Demande d'observateur",
    settings: 'Paramètres',
    profile: 'Profil'
  },
  login: {
    rememberMe: 'Se souvenir de moi',
    forgetPassword: 'Mot de passe oublié',
    agree: 'Se connecter signifie accepter FurCarer',
    privacyPolicy: 'Politique de confidentialité',
    CGMUser: 'Utilisateur CGM',
    follower: 'Suiveur',
    ruleMsgPassword: 'Veuillez entrer le mot de passe',
    login: 'Se connecter',
    phonePlacehold: 'Veuillez entrer le numéro de téléphone',
    codePlacehold: 'Veuillez entrer le code de vérification',
    codePlaceholdInput: 'Veuillez entrer t...',
    phoneTip: 'Par téléphone',
    emialTip: 'Par e-mail',
    codeTip: 'Obtenir le code de vérification',
    reGetTip: 'Récupération'
  },
  layout: {
    collapseUp: 'Masquer le menu',
    collapseDown: 'Développer le menu',
    refresh: 'Actualiser',
    backHome: 'Accueil',
    helpCenter: "Centre d'aide",
    fullScreen: 'Plein écran'
  },
  forget: {
    ruleMsgCode: 'Veuillez entrer le code',
    sendCode: 'Envoyer le code',
    tipsMsgSendSuccess: 'Le code de vérification a été envoyé avec succès !',
    tipsMsgModifySuccess: 'Modification du mot de passe réussie'
  },
  home: {
    title: 'FurCarer Portal',
    todaysGlucose: "Glucose aujourd'hui",
    todaysOverview: "Aperçu aujourd'hui",
    maxGlucose: 'Glucose max.',
    minGlucose: 'Glucose min.',
    avgGlucose: 'Glucose moyen',
    maxmumVariation: 'Variation maximale',
    glucose: 'Glucose',
    tir: 'TIR',
    latestGlucose: 'Dernier glucose',
    todayPercentage: "% d'aujourd'hui dans différentes plages",
    fourHour: '4 heures',
    eightHour: '8 heures',
    twelveHour: '12 heures',
    twentyFourHour: '24 heures',
    glucoseOnly: 'Glucose uniquement',
    sessionOverview: "Vue d'ensemble de la session",
    glocuseMetrics: 'Métriques de glucose',
    agp: 'AGP',
    dailyGlucose: 'Glucose quotidien',
    sessionGlucose: 'Glucose de la session',
    standTir: 'TIR standard',
    customTir: 'TIR personnalisé',
    cancleGz: 'Ne plus suivre',
    cancleText: 'Souhaitez-vous ne plus suivre cet utilisateur',
    helpCenterTip: 'Fonction non encore ouverte'
  },
  glucoseReport: {
    statics: 'Statistiques',
    sixHour: 'TIR de 6 heures',
    avgGlucose: 'Glucose moyen',
    maxGlucose: 'Glucose max.',
    minGlucose: 'Glucose min.',
    cv: 'CV',
    high: 'Nombre de hauts',
    low: 'Nombre de bas',
    normal: 'Nombre de normaux',
    tir: 'TIR',
    estimatedA1c: 'A1c estimé',
    min: 'Min',
    avg: 'Moyenne',
    max: 'Max',
    maxVariation: 'Variation maximale'
  },
  glucoseProfile: {
    avg: 'Moyenne',
    sd: 'Écart-type (SD)',
    cv: 'CV'
  },
  eventList: {
    all: 'Tout',
    bg: 'BG',
    meal: 'Repas',
    sport: 'Sport',
    insulin: 'Insuline',
    alert: 'Alerte',
    eventType: "Type d'événement",
    description: 'Description',
    note: 'Note',
    highAlert: "alerte d'avertissement",
    calibration: 'Calibration',
    meds: 'Médicaments',
    time: 'Heure',
    detail: 'Détail',
    weigt: 'Poids'
  },
  followerList: {
    title: 'Utilisateurs de suivi',
    tabTitle: 'Gestion des suiveurs',
    refreshText:
      'Actualisation automatique (la liste des utilisateurs se rafraîchit automatiquement toutes les 30 secondes)',
    addText: 'Ajouter',
    dataText: 'Données obtenues',
    timeText: 'minutes',
    hourText: 'heures',
    agoText: ' avant',
    tableEmail: 'Entrez le numéro de compte',
    searchPlacehold: 'Veuillez entrer votre numéro de compte pour rechercher',
    pending: 'En attente',
    approved: 'Approuvé',
    rejected: 'Rejeté',
    addFollower: 'Ajouter un suiveur',
    editFollower: 'Modifier un suiveur',
    tableName: 'Nom',
    tableAddTime: 'Ajouter le temps',
    tableStatus: 'Statut',
    tableApproved: 'Approuvé',
    tableReject: 'Rejeter',
    tableStartSharing: 'Commencer le partage',
    tableStopSharing: 'Arrêter le partage',
    op: 'Opérer',
    sharing: 'Partage',
    notSharing: 'Non partagé',
    tableRemove: 'supprimer',
    note: 'Note',
    message: 'Message',
    ruleMsgEmailEmpty: 'Veuillez entrer un e-mail pour rechercher',
    ruleMsgNote: 'Veuillez entrer une note',
    ruleMsgMessage: 'Veuillez laisser un message',
    ruleMsgEmailCorrect: 'Veuillez entrer le bon e-mail',
    formAcknowledge:
      "Je reconnais qu'ajouter un suiveur permettra à cet utilisateur de voir mes données",
    sendFollowRequest: 'Envoyer la demande de suivi',
    setNote: 'Définir la note',
    tipsAcknowledge:
      "Veuillez cocher la case, vous reconnaissez qu'ajouter un suiveur permettra à cet utilisateur de voir mes données",
    stopSharing: 'Arrêter le partage',
    startSharing: 'Commencer le partage',
    removeUser: "Supprimer l'utilisateur",
    confirmStopSharing:
      'Êtes-vous sûr de vouloir arrêter de partager le glucose avec cet utilisateur ?',
    confirmStartSharing:
      'Êtes-vous sûr de vouloir commencer à partager le glucose avec cet utilisateur ?',
    confirmRemove:
      'Êtes-vous sûr de vouloir supprimer cet utilisateur de la liste ?',
    approvedFollower: 'Abonné approuvé',
    rejectFollower: "Refuser l'abonnement",
    confirmApproved:
      "Êtes-vous sûr de vouloir approuver cette demande d'abonnement ?",
    confirmReject:
      "Êtes-vous sûr de vouloir rejeter cette demande d'abonnement ?",
    addTime: 'Ajouter le temps',
    check: 'Vérifier',
    remove: 'Supprimer',
    removeUserTitle:
      'Êtes-vous sûr de vouloir supprimer cet utilisateur de la liste ?'
  },
  settings: {
    title: 'Paramètres du niveau de glucose',
    unitSet: "Paramètre d'unité",
    targetSet: 'Paramètre TIR personnalisé',
    alertSet: "Paramètre d'alerte",
    highAlert: 'Alerte élevée',
    lowAlert: 'Alerte faible',
    urgentLow: 'Alerte urgente basse',
    urgentHigh: 'Alerte urgente élevée',
    target: 'Cible'
  },
  pdf: {
    dailyStatistics: 'Statistiques quotidiennes',
    title: 'Rapport AGP',
    page: 'Page',
    generated: 'Généré',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Temps dans la plage',
    timeInRange: 'Temps dans la plage (TIR)',
    agpTitle: 'Profil ambulatoire de glucose (AGP)',
    agpSubTitle:
      "L'AGP est un résumé des valeurs de glucose pendant la période du rapport, avec la médiane (50%) et d'autres percentiles affichés comme s'ils se produisaient en une seule journée",
    dailyTitle: 'Profil quotidien de glucose',
    dailySubTitle:
      'Chaque profil quotidien représente une période de minuit à minuit.',
    device: 'Appareil',
    tDevice: 'Appareil terminal',
    print: 'Imprimer',
    model: 'Modèle',
    deviceSn: "Numéro de série de l'appareil",
    effectiveData: 'Données effectives',
    days: 'Jours',
    appVer: "Version de l'application",
    smartPhoneModel: 'Modèle de téléphone intelligent',
    osVersion: "Version du système d'exploitation",
    appSetting: "Paramètre de l'application",
    GoalsforType1andType2Diabetes:
      'Objectifs pour le diabète de type 1 et type 2',
    Each1timeinrange15minutes: 'Chaque 1% de temps dans la plage =~15 minutes',
    note: 'Note: The % unit is applicable to the DCCT standard, and the mmol/mol unit is applicable to the IFCC standard.',
    DOB: 'DOB',
    SN: 'SN'
  },
  field: {
    timeCgmActive: 'Temps de CGM actif',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Moyenne des calibrations par jour',
    glucoseAbility: 'Variabilité du glucose',
    lage: 'Lage',
    mage: 'Mage',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Nombre de calibrations'
  },
  agp: {
    agpTitle: 'Profil ambulatoire de glucose (AGP)',
    centerLine: 'Médiane',
    areaLine: 'Intervalle',
    target: 'Plage cible'
  },
  basic: {
    customTir: 'TIR personnalisé',
    bloodTip: 'Paramètres de rappel de glucose',
    bloodUnit: 'Unité de glucose',
    highTip: 'Alerte de glucose élevé',
    lowTip: 'Alerte de glucose bas',
    unitText: 'Réglage automatique basé sur la région du pays',
    selectTip:
      "Cliquez sur l'icône pour sélectionner ou désélectionner la date correspondante",
    selectAll: 'Sélectionner tout'
  },
  report: {
    threeMonth: 'Les 3 derniers mois',
    sixMonth: 'Près de 6 mois',
    yearText: "L'année dernière",
    showAll: 'Afficher tout',
    all: 'Tout',
    selectDate: 'Sélectionner la plage de dates',
    to: 'à',
    startDt: 'Date de début',
    endDt: 'Date de fin',
    betaTest: 'Test bêta',
    bloodData: 'Données de glucose',
    userCount: 'Compte utilisateur'
  },
  petDetail: {
    variety: 'Race',
    type: "Type d'insuline",
    freq: "Fréquence de l'insuline",
    lente: 'Lente',
    insulin: 'Insuline Glargine',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'Rapport AGP',
    snNumber: 'Numéro de série',
    page: 'Page',
    createTime: 'Généré',
    petInfo: "Informations sur l'animal de compagnie",
    petName: "Nom de l'animal",
    birthday: 'Date de naissance',
    freq: "Fréquence de l'insuline",
    petType: "Type d'animal",
    age: 'Âge',
    registerType: 'Type de seringue',
    basicBloodData: 'Métriques de glucose',
    dbText: 'Temps dans la plage (TIR)',
    target: 'Objectifs pour le diabète de type 1 et type 2',
    recordTime: "Temps d'enregistrement",
    tag: 'Étiquette',
    event: 'Événement',
    eventDetail: "Détails de l'événement",
    mulityText: 'Graphique de tendance du glucose sur plusieurs jours',
    mulitySubText:
      "Les profils de glucose sur plusieurs jours représentent l'intervalle de temps d'un cycle de l'appareil",
    avageBlood: 'Glycémie moyenne',
    bloodText: 'MODD',
    highTip: 'Alerte de glucose élevé',
    lowTip: 'Alerte de glucose bas',
    cat: 'Chat',
    dog: 'Chien',
    country: 'Pays',
    insulinDose: "Dose d'insuline",
    weightUnit: 'kg'
  },
  eventDetail: {
    Empty: 'Vide',
    After_Breakfast: 'Après le petit-déjeuner',
    Before_Lunch: 'Avant le déjeuner',
    Breakfast: 'Petit-déjeuner',
    Lunch: 'Déjeuner',
    Dinner: 'Dîner',
    Before_Sleep: 'Avant de dormir',
    Extra: 'Supplémentaire',
    Short_acting: 'Action rapide',
    Pre_mixed: 'Pré-mélangé',
    Long_acting: 'Action prolongée',
    Middle_acting: 'Action intermédiaire',
    hour: 'h',
    minutes: 'min'
  }
};
export default fr;
